module.exports = __webpack_public_path__ + "media/assets/arrow-bottom-right-b994e2cd38a04f58310ce074cd854e991154a220f8ce3aa867d7e4965da43fa9.png";